var _path, _path2, _path3, _path4;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgSuccessCheckmark = function SvgSuccessCheckmark(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.874 27.145c.08.564.08 1.209.08 1.772 0 12.647-10.31 23.038-23.036 23.038-12.727 0-22.957-10.31-22.957-23.038C5.96 16.271 16.27 5.88 28.998 5.88a22.751 22.751 0 0 1 13.935 4.753l3.786-3.706C41.886 2.98 35.684.644 29 .644 13.371.724.724 13.371.724 28.917c0 15.627 12.646 28.273 28.193 28.273 15.546 0 28.273-12.646 28.273-28.273 0-2.175-.242-4.269-.725-6.202l-4.592 4.43Z",
    fill: "#88C8C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.904 37.859-9.183-9.586c-.967-1.047-.967-2.738.08-3.705 1.048-.967 2.74-.967 3.706.08l6.927 7.25a1.168 1.168 0 0 0 1.692 0L55.58 7.33a2.652 2.652 0 0 1 3.705.08 2.651 2.651 0 0 1-.08 3.706l-27.79 26.823c-1.29 1.289-3.303 1.208-4.511-.08Z",
    fill: "#009F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m56.949 22.232-1.047 1.047c.402 1.853.644 3.786.644 5.639 0 15.143-12.324 27.548-27.548 27.548-15.224 0-27.548-12.325-27.548-27.549C1.45 13.774 13.774 1.37 28.998 1.37c6.202 0 12.324 2.175 17.157 6.042l1.047-.967A28.877 28.877 0 0 0 28.998 0C12.968 0 0 12.969 0 28.918c0 15.948 12.969 28.917 28.918 28.917 15.948 0 28.917-12.969 28.917-28.918 0-2.255-.242-4.51-.806-6.766l-.08.08Z",
    fill: "#009F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m26.904 37.859-9.183-9.586c-.967-1.047-.967-2.738.08-3.705 1.048-.967 2.74-.967 3.706.08l6.927 7.25a1.168 1.168 0 0 0 1.692 0L55.58 7.33a2.652 2.652 0 0 1 3.705.08 2.651 2.651 0 0 1-.08 3.706l-27.79 26.823c-1.29 1.289-3.303 1.208-4.511-.08Z",
    fill: "#009F80"
  })));
};

export { SvgSuccessCheckmark as ReactComponent };
export default "/_next/static/media/success-checkmark.70b7c0a9.svg";